import FormsInputMaterial from "@olmokit/core/forms/input/material";
import "@olmokit/core/forms/checkbox";
import Olmoforms from "@olmokit/core/olmoforms/feedback";
import Dependency from "@olmokit/core/olmoforms/dependency";
import { $, $all, on, removeClass } from "@olmokit/dom";
import { AjaxConfig, Ajax } from "@olmokit/core/ajax";
import { dataLayerFillingForm, dataLayerNewsForm } from "components/Datalayer";
import { globalConf } from "@olmokit/core/data";
import { salesforceCommunication } from "components/Form";
import axios from 'axios';
import "./Newsletter.scss";

/**
 * Component: FormNewsletter
 */
export function FormNewsletter() {
  console.log("FormNewsletter mounted.");

  dataLayerFillingForm('.of:el', 'Form Newsletter')

  const olmoforms = Olmoforms(".FormNewsletter:", {
    before: (formData) => {
      console.log(formData);
      const $localcheck = $('#of-2-localcheck');
      if($localcheck.value != ''){
        console.log('stopped');
        olmoforms.boot()
      }
      grecaptcha.ready(function() {
        grecaptcha.execute('6Lf-wxorAAAAAIdTqMQ_Ah0OHludYUF6ga-iDaPC', { action: 'submit' }).then(function(token) {
            // Add your logic to submit to your backend server here.
            console.log('token', token);   

            axios.post(globalConf.cmsApiUrl+'/'+'recaptcha', {
              token: token
            })
            .then(() => {
              console.log('recaptcha done');
            })
            .catch((error) => {
              console.log(error);
              olmoforms.boot()
            });

        });
      });       
    },
    sent: (formData) => {
      dataLayerNewsForm("form sent", formData);
      salesforceCommunication(formData, "Newsletter");
    }, 
    failed: (instance) => {
      dataLayerNewsForm("form_error", '')
    } 
  });

  FormsInputMaterial();
  Dependency(".FormNewsletter:");

  return {
    destroy() {
      olmoforms.destroy();
    },
  };


}
